<template>
  <v-app>
    <AppBar />
    <Drawer />
    <CoreView />
  </v-app>
</template>

<script>
import AppBar from "@/views/AppBar";
import Drawer from "@/views/Drawer";
import CoreView from "@/views/CoreView";

export default {
  name: "Home",
  components: { AppBar, Drawer, CoreView }
};
</script>
